import { queryKeys } from "./query-keys";
export const matterDetailQueryKey = (matterId: string | undefined) =>
  [
    queryKeys.matters,
    matterId,
    "v4",
    "matter",
    { history: false, connectionLimit: 25 },
  ] as const;
